@for (obj of cardContent; track $index) {
  <div class=" app-card" [ngClass]="obj.class" *ngIf="obj.visible">
    @for (item of obj.items; track item.index) {
      <div class="p-0 card-item">
        <p class="font-12 font-bold app-text-gray">{{ item.descripcionCard }}</p>
        <h3 class="color-form-label font-weight-light  font-roboto-condensed">
          <a class="font-18" [class]="item?.command ? 'cursor-pointer':''"
             (click)="item?.command ? item.command():null">{{ item.title }}</a>
        </h3>
        <div>
          <p *ngIf="item.content" class="mt-0 font-12 line-height-3 app-text-gray">
            {{ item.content }}
          </p>
          <div *ngIf="item.html"
               [innerHtml]="item.html | safeResource : 'html' "></div>
        </div>
        @if (item?.buttonLabel) {
          <button pButton [label]="item.buttonLabel ?item.buttonLabel : '' "
                  (click)="item?.command ? item.command({ originalEvent: $event, item: item }) : null"
                  class="bg-button-outline-blue-light  border-outline-blue-light text-blue-general font-normal	w-full"
                  iconPos="right" [icon]=" 'pi ' + item.icon "></button>
        }
      </div>
    }
  </div>
}




